import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";

export default class TenByTenMoonAnimation {
	constructor() {
		this.moon = document.querySelector(".tenbyten-moon");
		if(!this.moon) return;

		this.rotation = 0;
		this.direction = 1;
		this.moonFire = this.moon.querySelector(':scope > img:last-child');

		this.autoRotation;
		this.handleScroll();
	}

	updateRotation(rotation) {
		if((this.direction > 0 && this.rotation > 360) || (this.direction < 0 && this.rotation < -360)) {
			return 0;
		} else {
			return rotation;
		}
	}

	setRotation() {
		const moons = document.querySelectorAll(".tenbyten-moon");

		moons.forEach(moon => {
			const fire = moon.querySelector(':scope > img:last-child');
			gsap.set(fire, {rotation: this.rotation});
		})
	}

	autoRotate() {
		if(!this.disableAuto) {
			this.rotation = this.updateRotation(this.rotation + .1 * this.direction);
		} else {
			window.setTimeout(() => {
				this.disableAuto = false
			}, 100);
		}

		this.setRotation(this.rotation);
	}

	handleScroll() {
		this.autoRotation = () => this.autoRotate();

		gsap.ticker.add(this.autoRotation);

		ScrollTrigger.observe({
			target: window,
			type: 'wheel',
			onChangeY: (self) => {

				this.disableAuto = true;

				this.direction = self.deltaY > 0 ? 1 : -1;
				this.rotation = this.rotation + self.deltaY * .1;
				this.setRotation(this.rotation);
			},
		});
	}
}
